import { request, unwrap } from '../client';
import type {
  ApiResponse,
  FontOption,
  ThemePreviewResponse,
  ThemeResponse,
  ThemeSaveInput,
} from '../types';

const BASE = '/api/saas-admin/brands';

/**
 * SASADM-0154 — the brand theme editor API (saas-auth SASATH-0346, handoff
 * "go" §3). The whole `input` is always sent: a missing colour clears it, and
 * only a missing container (e.g. `cornerStyle`) keeps the stored value.
 */
export const brandThemeApi = {
  async get(brandId: number): Promise<ThemeResponse> {
    const res = await request<ApiResponse<ThemeResponse>>('GET', `${BASE}/${brandId}/theme`);
    return unwrap(res);
  },

  /** Resolves `input` without saving; the body is the bare input. */
  async preview(brandId: number, input: ThemeSaveInput): Promise<ThemePreviewResponse> {
    const res = await request<ApiResponse<ThemePreviewResponse>>(
      'POST',
      `${BASE}/${brandId}/theme/preview`,
      { json: input },
    );
    return unwrap(res);
  },

  /** 409 `THEME_CHANGED` on a stale etag; 422 `THEME_CONTRAST_FAILED` with `error.failures`. */
  async save(brandId: number, input: ThemeSaveInput, etag: string): Promise<ThemeResponse> {
    const res = await request<ApiResponse<ThemeResponse>>('PUT', `${BASE}/${brandId}/theme`, {
      json: { input, etag },
    });
    return unwrap(res);
  },

  /** Public Google Fonts allowlist. */
  async fonts(): Promise<FontOption[]> {
    const res = await request<ApiResponse<FontOption[]>>('GET', '/api/branding/fonts');
    return unwrap(res);
  },
};
